// eslint-disable-next-line import/prefer-default-export
export const DEBOUNCE = 500;



// WEBPACK FOOTER //
// ./src/configuration/autocompleteConf.js